import { SelectFieldProps } from 'ui/SelectField';
import FormSelectField from 'ui/FormSelectField';
import IsoCountryCodes from 'constants/IsoCountryCodes';

interface Props extends Pick<SelectFieldProps, Exclude<keyof SelectFieldProps, 'children'>> {
  children?: React.ReactNode;
}

const FormIsoCountryCodeField: React.FunctionComponent<Props> = ({
  name = 'isoCountryCode',
  id = 'isoCountryCode',
  label = 'Country',
  SelectProps = {
    inputProps: {
      'data-testid': 'country-code',
      autoComplete: 'country',
    },
  },
  fullWidth = true,
  ...rest
}) => {
  return (
    <FormSelectField
      fullWidth={fullWidth}
      name={name}
      id={id}
      label={label}
      SelectProps={SelectProps}
      {...rest}
    >
      <option value="" />
      {IsoCountryCodes.map(({ value, key, label }) => (
        <option value={value} key={key}>
          {label}
        </option>
      ))}
    </FormSelectField>
  );
};

export default FormIsoCountryCodeField;
